
function setCookie(cname, cvalue, exdays) {
  console.log('set cookie executed');
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  
  jQuery('.cookie-disclaimer').addClass('hide');
}



function getCookie(cname) {
  console.log('get cookie executed');
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*function checkCookie() {
  var user = getCookie("sebastion-says");
  console.log("Cookie checker value = " + user);
  if (user === "1") {
    alert("Welcome again " + user);
  } else {
    console.log('Hi new user');
    jQuery('.cookie-disclaimer').removeClass('hide');
  }
}*/



function scaleToFill() {
	$('video').each(function(index, videoTag) {
		var $video = $(videoTag),
			videoRatio = videoTag.videoWidth / videoTag.videoHeight,
			//videoRatio = 1.7777777778,
			tagRatio = $video.width() / $video.height(),
			val;
		//console.log(videoTag.videoHeight, videoRatio, tagRatio);
		if (videoRatio < tagRatio) {
			val = tagRatio / videoRatio * 1.02;
		} else if (tagRatio < videoRatio) {
			val = videoRatio / tagRatio * 1.02;
		}
		console.log(val);

		$video.css('transform', 'scale(' + val + ',' + val + ')');
	});
}

var iframeLoaded = false;
$(document).ready(function() {
  
	if ($(window).width() > 768) {
		$('video').on('loadedmetadata', scaleToFill);
	}

	$(window).resize(function() {
		scaleToFill();
	});
  
//     var iframeHeight = document.querySelector('.puzzle_block-iframe').contentWindow.document.body.scrollHeight;
//     $('.puzzle_block-iframe').css('height',iframeHeight);
//    	console.log(iframeHeight);




    $('.puzzle_block-iframe').load(function() {
      if(!iframeLoaded) {
        iframeLoaded = true;
        const referralId = gup('referral_id');
        const oldUrl = $('.puzzle_block-iframe').attr('src');

        if(referralId) {
          console.log('iframe loaded');


          $('.puzzle_block-iframe').attr('src',`${oldUrl}?referral_id=${referralId}&val=${Math.round(Math.random() * 10000000)}`);
//           $('.puzzle_block-iframe').attr( 'src', function ( i, val ) { return val; });
          
        } else {
          $('.puzzle_block-iframe').attr('src',`${oldUrl}?val=${Math.round(Math.random() * 10000000)}`); 
        }

        
      }
    });
  


  $('.top-banner-slick').slick({
      dots: false,
    arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
  });

  $('#header-search-popout').on('click', function(e){
    e.preventDefault();
  	$('.custom-header-search').toggleClass('open');
    $(this).toggleClass('open');
  });

// 	var mycookie = getCookie('sebastion-says');
//   	console.log(mycookie);
  
//   	if(mycookie !== '1'){
//       	$('.cookie-disclaimer').toggleClass('hide');
//     }else {
//       	$('.cookie-disclaimer').addClass('hide');
//     }
  
//   $('.cookie-btn').on('click', function(){
// 		setCookie('sebastion-says', '1', 365);
//   });
  
  
  $('.main-menu li a').on('click', function(e) {
    e.preventDefault();
    
  });
  
  /*$('.hamburger').on('click', function(e) {
    e.preventDefault();
    $('.mobile-nav-lower-wrapper').toggleClass('hide');
  });*/
  
    $(".nav-list-wrapper ul li").each(function() {
    var _this = $(this);
    var this_info = _this.attr("data-nav");
    _this.on("mouseenter click tap", function() {
      $(".nav-lower-wrapper").removeClass("hide");
      $(".nav-list-wrapper ul li h3").removeClass("nav-selected");
      $(".nav-list-wrapper ul li")
        .find('h3[data-nav="' + this_info + '"]').addClass("nav-selected");   
      $(".sublist-wrapper").hide();
      $(".nav-sublist-wrapper")
        .find('div[data-nav="' + this_info + '"]')
        .show();
      $(".nav-image-wrapper a").hide();
      $(".nav-image-wrapper").find('a[data-nav="' + this_info + '"]').show();
    });
      
       $(".nav-list-content").on("mouseleave", function() {
      	$(".nav-lower-wrapper").addClass("hide");
 		$(".nav-list-wrapper ul li h3").removeClass("nav-selected");
      });
  });
  
  
      $(".mobile-header").each(function() {
    var _this = $(this);
    var this_info = _this.attr("data-nav");
      $(".mobile-menu-wrapper").addClass('hide');
    _this.on("click", function() {

      $(".mobile-header h3").removeClass("mobile-nav-selected");
      $(".mobile-header")
        .find('h3[data-nav="' + this_info + '"]').addClass("mobile-nav-selected");   
//       $(".mobile-menu-wrapper").toggleClass('hide');
      $(".mobile-nav-lower-wrapper")
        .find('div[data-nav="' + this_info + '"]')
        .toggleClass('hide');
  });
        

      
});
  
  
  $('.open-popup').magnificPopup({
  		type:'inline',
  		midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});
  
  			var menu = new MmenuLight( document.querySelector( '#menu' ), {
				// title: 'Menu',
				// theme: 'light',// 'dark'
				 slidingSubmenus: false,// false
				// selected: 'Selected'
			});
			menu.enable( 'all' ); // '(max-width: 900px)'
			menu.offcanvas({
				 position: 'left',// 'right'
				 move: true,// false
				// blockPage: true,// false / 'modal'
			});

			//	Open the menu.
			document.querySelector( 'a[href="#menu"]' )
				.addEventListener( 'click', ( evnt ) => {
					menu.open();

					//	Don't forget to "preventDefault" and to "stopPropagation".
					evnt.preventDefault();
					evnt.stopPropagation();
				});
  
  
  
});




// Query string getter
function gup(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.href);
	if (results == null) return false;
	else return results[1];
}

